module.exports = __webpack_public_path__ + "img/FaceAI-mockup2.99e08c06.png";